import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AppRoute } from '../config/route-config';
import { UserProvider } from '../context/user/UserProvider';
import { UserFetcher } from '../components/UserFetcher/UserFetcher';
import CustomerServiceProvider from '../context/CustomerService/CustomerServiceProvider';
import CsmResolved from '../components/CustomerServiceManagement/CSResolved/getResolvedTickets';
import CsmClosed from '../components/CustomerServiceManagement/CSClosed/GetClosedTickets';
import CsmSearch from '../components/CustomerServiceManagement/CSSearch/getSearchTickets';
import { CSNew } from '../components/CustomerServiceManagement/CSNew/CSNew';
import CsmOpen from '../components/CustomerServiceManagement/CSOpen/getOpenTickets';
import CsmOpenByMe from '../components/CustomerServiceManagement/CSOpenByMe/getOpenByMeTickets';
import { CSInfo } from '../components/CustomerServiceManagement/CSInfo/CSInfo';
import { ReferenceProvider } from '../context/CustomerService/ReferenceProvider';
import { StoreProvider } from '../context/Store/StoreProvider';

export const routesTestId = 'routesTestId';

const SearchRoute = () => (
  <StoreProvider>
    <ReferenceProvider>
      <CsmSearch />
    </ReferenceProvider>
  </StoreProvider>
);

const NewRoute = () => (
  <ReferenceProvider>
    <CSNew />
  </ReferenceProvider>
);

const InfoRoute = () => (
  <ReferenceProvider>
    <CustomerServiceProvider>
      <CSInfo />
    </CustomerServiceProvider>
  </ReferenceProvider>
);

export const Routes = () => {
  return (
    <UserProvider>
      <UserFetcher />
      <div data-testid={routesTestId}>
        <Switch>
          <Route exact path={AppRoute.Index}>
            <Redirect to={AppRoute.Search} />
          </Route>

          <Route exact path={AppRoute.Resolved} component={CsmResolved} />
          <Route exact path={AppRoute.Closed} component={CsmClosed} />
          <Route exact path={AppRoute.Search} component={SearchRoute} />
          <Route exact path={AppRoute.Open} component={CsmOpen} />
          <Route exact path={AppRoute.OpenByMe} component={CsmOpenByMe} />
          <Route exact path={AppRoute.New} component={NewRoute} />
          <Route exact path={AppRoute.Info} component={InfoRoute} />
        </Switch>
      </div>
    </UserProvider>
  );
};
